import ProfileIcon from "@components/Profile/ProfileIcon";
import Link from "next/link";
import ThemeChanger from "../shared/ThemeChanger";
import OrganizationPicker from "@components/shared/OrganizationPicker";
import { ImpersonationIndicator } from "@components/Admin/ImpersonationIndicator";

export default function NavBar() {
  return (
    <nav className="fixed z-10 h-12 w-full border-b border-muted bg-background ">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="navbar-start flex items-center gap-2 whitespace-nowrap">
          <Link
            href={`/`}
            className="cursor-pointer font-semibold text-foreground"
          >
            Signage Studio
          </Link>
          <OrganizationPicker />
        </div>
        <div className="flex flex-row">
          <ImpersonationIndicator />
          <ThemeChanger />

          <ProfileIcon />
        </div>
      </div>
    </nav>
  );
}
